import { useEffect, useRef, useState, type FC } from "react";
import type { ModalProps } from "@uhg-harmony/react";
import { BaseTemplateFormModal, type BaseTemplateFormData } from "./BaseTemplateFormModal";
import { useAppSelector } from "../../redux/hooks";
import { selectCategory } from "../../redux/metadata/metadataSlice";

type RenameModalProps = ModalProps & {
  open: boolean;
  onClose: () => void;
  onConfirm: (formData: BaseTemplateFormData) => void;
  templateName?: string;
  templateId?: string;
  isLoading?: boolean;
  errorMessage?: string;
};

export const RenameModal: FC<RenameModalProps> = ({
  title,
  open,
  onClose,
  onConfirm,
  templateName,
  templateId,
  isLoading = false,
  errorMessage = "",
}) => {
  const category = useAppSelector(selectCategory);
  const [fixedCategory, setFixedCategory] = useState(category || "Global");
  const wasOpenRef = useRef(false);

  useEffect(() => {
    const justOpened = open && !wasOpenRef.current;
    if (justOpened) {
      setFixedCategory(category || "Global");
    }
    wasOpenRef.current = open;
  }, [open, category]);

  return (
    <BaseTemplateFormModal
      title={title || "Rename Template"}
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      initialTemplateName=""
      displayTemplateName={templateName}
      currentTemplateId={templateId}
      confirmButtonText="Rename"
      isLoading={isLoading}
      errorMessage={errorMessage}
      fixedCategory={fixedCategory}
      defaultFolderSelection="Drafts"
    />
  );
};
